import React, { useState, useEffect } from 'react';
import '../Assets/css/dashboard.css';
import { BsGrid1X2 } from "react-icons/bs";
import { MdOutlineLogout } from "react-icons/md";
import { TbListSearch } from "react-icons/tb";
import { GoTasklist } from "react-icons/go";
import SmartHDlogo from '../Assets/img/SmartHelpdeskLogo.png';
import Home from './home';
import Track from './Track';
import AllTask from './AllTask';
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';


const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: '14px',
    },
}));

function Dashboard() {
    const navigate = useNavigate();
    const userName = localStorage.getItem("UserName");
    const [activeTab, setActiveTab] = useState('home');

    useEffect(() => {
        // Push the current state to the history
        window.history.pushState(null, null, window.location.href);

        const handlePopState = () => {
            // Prevent going back
            window.history.go(1);
        };

        // Add event listener for popstate
        window.addEventListener('popstate', handlePopState);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    const handleTabs = (val) => {
        setActiveTab(val);
    }

    const tabComponents = {
        home: <Home />,
        track: <Track />,
        'All Task': <AllTask />
    };

    return (
        <div className='DashboardParent'>
            <div className='NavBarParent'>
                <div className='NavBarLogoSection'>
                    <img src={SmartHDlogo} alt='smart_helpdesk' className='SmartHelpdeskLogo' onClick={() => handleTabs('home')} />
                </div>

                <div className='NavBarTabsDiv'>
                    <div className={activeTab === 'home' ? 'NabBardTabSubActive' : 'NabBardTabSub'}
                        onClick={() => handleTabs('home')}
                    >
                        <BsGrid1X2 className={activeTab === 'home' ? 'IoHomeNavStyActive' : 'IoHomeNavSty'}
                            style={{ strokeWidth: "0.3" }} />
                        <span className='NavTabText'>Home</span>
                    </div>

                    <div className={activeTab === 'track' ? 'NabBardTabSubActive' : 'NabBardTabSub'}
                        onClick={() => handleTabs('track')}
                    >
                        <TbListSearch className={activeTab === 'track' ? 'IoHomeNavStyActive1' : 'IoHomeNavSty1'} />
                        <span className='NavTabText'>Track</span>
                    </div>

                    {/* <div className={activeTab === 'All Task' ? 'NabBardTabSubActive' : 'NabBardTabSub'}
                        onClick={() => handleTabs('All Task')}
                    >
                        <GoTasklist className={activeTab === 'All Task' ? 'IoHomeNavStyActive1' : 'IoHomeNavSty1'} />
                        <span className='NavTabText'>All Task</span>
                    </div> */}
                </div>

                <div className='NavBarUserSection'>
                    <div className='UserDetailDiv'>
                        <div className='UserLogoDiv'>
                            <span className='NavBarUserFirstLetter'>{userName.charAt(0).toUpperCase()}</span>
                        </div>
                        <span className='NavBarUserText'>{userName}</span>
                    </div>

                    <button className='LogoutBtn' onClick={() => { navigate('/'); localStorage.setItem("EmpID", ''); }}>
                        <BootstrapTooltip title={"Logout"} placement="bottom">
                            <MdOutlineLogout className='IoIosLogOutSty' />
                        </BootstrapTooltip>
                    </button>
                </div>
            </div>

            {/* <div className='ContentSectionParent'>
                {activeTab === 'home' ? <Home /> : activeTab === 'track' ? <Track /> : activeTab === 'All Task' ? <AllTask /> : <Home />  }
            </div> */}

            <div className='ContentSectionParent'>
                {tabComponents[activeTab] || <Home />}
            </div>

        </div>
    )
}

export default Dashboard;